/**
 * A caught error as a line for a person, at two levels of candor.
 *
 * A product's own page says what happened in a sentence and no more; an
 * internal page says everything the browser was handed, because the person
 * reading it is the one who will go and look at the server, and a message
 * that hides the status, the content type and the body is a message they
 * have to reproduce the failure to get.
 */import{GraphqlTransportError}from"web/shared/relay/transport";// The same, with everything a transport failure recorded appended.
export function internalErrorMessage(error,fallback){if(error instanceof GraphqlTransportError){return"".concat(error.message," \u2014 ").concat(error.detail);}return errorMessage(error,fallback);}// The error's own words, or the fallback for one that has none.
export function errorMessage(error,fallback){if(error instanceof Error&&error.message.length>0){return error.message;}return fallback;}